import http from '../../../../../api/http';

const BASE_URL = '/mypage/jobFair';
const API_URL = `${BASE_URL}/applicant`;

// 입사지원 여부 확인
function retrieveApplicantByUserId(params) {
    return http.post(`${API_URL}/retrieveApplicantByUserId`, params)
}

// 입사지원
function createApplicant(params) {
    return http.post(`${API_URL}/createApplicant`, params)
}

// 입사지원 상태 변경
function updateApplyStateGb(params) {
    return http.post(`${API_URL}/updateApplyStateGb`, params)
}

// 특정이력서로 입사지원한 채용공고 리스트 페이징 조회
function retrieveApplicantListPaging(params) {
    return http.post(`${API_URL}/retrieveApplicantListPaging`, params)
}

// 채용공고에 입사지원한 인재 리스트 페이징 조회
function retrieveApplicantListPagingByJobNoticeSeq(params) {
    return http.post(`${API_URL}/retrieveApplicantListPagingByJobNoticeSeq`, params)
}

export default {
    retrieveApplicantByUserId,
    createApplicant,
    updateApplyStateGb,
    retrieveApplicantListPaging,
    retrieveApplicantListPagingByJobNoticeSeq,
};